import RateChart from './RateChart';

export default RateChart;